import React, {Component} from 'react';
import Select from "react-select";

import '@assets/sass/components/form/select.scss';

const renderOptions = (optionsAmount) => {
    const options = [];

    for (let i = 1; i <= optionsAmount; i++) {
        options.push(
            {value: i, label: i},
        );
    }

    return options;
}

export default class extends Component {
    state = {
        selectedOption: null,
    }

    componentDidMount() {
        const {initialValue} = this.props;

        if (!initialValue) return;

        this.setState({
            selectedOption: {
                value: initialValue,
                label: initialValue
            }
        })
    }

    handleChange = (selectedOption) => {
        const {isValueInherited, onChange} = this.props;

        if (isValueInherited) {
            onChange(selectedOption.value)
        } else {
            this.setState({selectedOption});
            onChange(selectedOption.value)
        }
    }

    getValue = () => {
        const {selectedOption} = this.state;
        const {inheritedValue, isValueInherited} = this.props;
        
        return inheritedValue ? {label: inheritedValue, value: inheritedValue} : selectedOption;
    }


    render() {
        const {placeholder, optionsAmount, isSearchable} = this.props;

        return (
            <Select
                value={this.getValue()}
                onChange={this.handleChange}
                options={renderOptions(optionsAmount)}
                className="form-controller--select"
                classNamePrefix="form-controller--select"
                placeholder={placeholder}
                isSearchable={isSearchable || false}
            />
        );
    }
}
